<template lang="pug">
div
  h2.title Processos analisados pela Prefeitura

  el-row(:gutter="10")

    el-col(:lg="8", :md="12", :sm="24")
      p.label Nome/Razão social do interessado:
      el-input.input(
        @keyup.native.enter="consultar"
        name="nomeInteressado",
        type="text",
        v-model="filtroSearch.nomeInteressado"
      )

    el-col(:lg="8", :md="12", :sm="24")
      p.label CPF/CNPJ do interessado:
      el-input(
        @keyup.native.enter="consultar"
        type="text",
        name="cpfInteressado",
        v-mask="['###.###.###-##', '##.###.###/####-##']",
        v-model="filtroSearch.cpfInteressado"
        )

    el-col(:lg="8", :md="12", :sm="24")
      p.label Número do processo:
      el-input.input(
        @keyup.native.enter="consultar"
        name="numeroProcesso",
        type="text",
        v-model="filtroSearch.numeroProcesso"
      )

  el-row.button-row
    span.limpar(@click="limpar") Limpar
    el-button(type="primary", @click="consultar")
      i.icon(class="fa fa-search")
      | Pesquisar

  h2 Listagem
  div.main.hidden-xs-only
    app-listagem-processos-analisados(
      v-if="processos.content"
      :processos="processos.content",
      :totalItems.sync="processos.totalElements || 0",
      @changePage="changePage",
      @clicked="onClickedProcessoListagem",
      @changeOrder="changeOrder"
      :page-size="pageSize"
      :currentPage="page",
      :loading="loadingTable"
    )

</template>

<script>
import { mapActions } from 'vuex'
import _ from 'lodash'
import EnumFormatter from '../../../../utils/EnumFormatter'
import AppListagemProcessosAnalisados from './AppListagemProcessosAnalisados'
import AppUploadArea from '@/components/AppUploadArea'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {

  components: {
    AppListagemProcessosAnalisados,
    AppUploadArea
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      page: 1,
      disableExportarCSV: true,
      filtroSearch: {
        pagina: 0,
        nomeInteressado: null,
        cpfInteressado: null,
        dataInicio: [],
        dataFim: [],
        tiposProcesso: [],
        municipios: [],
        situacoesProcesso: [],
        setoresAtuais: [],
        setoresPassados: ['PREFEITURA'],
        responsaveisAtuais: [],
        tipoPesquisa: 'SIMPLIFICADO',
        ordem: 'numeroProcesso',
        numeroProcesso: null,
        numeroComprovante: null,
        nomePlanilha: null
      },
      dataCadastro: [],
      tiposProcesso: [],
      municipios: [],
      status: [],
      setores: [],
      clickedProcesso: {},
      responsaveisAtuais: [],
      responsaveisPassados: [],
      processos: [],
      file: null,
      showPesquisaLote: false,
      validExtensions: ['xlsx', 'xls', 'csv']
    }
  },

  async created () {
    const filterInfo = await this.getFilterInfo()

    this.tiposProcesso = filterInfo.tiposProcesso
    this.municipios = filterInfo.municipios
    this.setores = filterInfo.setores
    this.status = filterInfo.status
    this.consultar()

    this.disableExportarCSV = this.processo > 0
  },

  props: {
    pageSize: {
      type: Number,
      default: 15
    },
    loading: {
      Type: Boolean,
      default: false
    }
  },

  methods: {
    ...mapActions({
      getCountProcessos: 'dashboardRelatorios/getCountProcessos',
      findProcessosByFilter: 'dashboardRelatorios/findProcessosByFilter',
      getCsvDashboardRelatorios: 'dashboardRelatorios/getCsvDashboardRelatorios',
      getFilterInfo: 'dashboardRelatorios/getFilterInfo',
      getTecnicosResponsaveis: 'dashboardRelatorios/getTecnicosResponsaveis',
      getModeloRelatorio: 'dashboardRelatorios/downloadModelo'
    }),
    getStatusFormatted (control) {
      const selectFormatted = _.orderBy(control)
      return selectFormatted.map(function (status) {
        return {
          nome: EnumFormatter.getStatusFormatado(status),
          codigo: status
        }
      })
    },
    getSetorFormatted (setor) {
      const setores = setor.filter(setor => (setor.codigo !== 'AGENDAMENTO') && (setor.codigo !== 'PARAMETRIZACAO'))
      const selectFormatted = _.orderBy(setores, ['codigo'], ['asc'])
      return selectFormatted
    },
    getOrdered (control) {
      const selectFormatted = _.orderBy(control)
      return selectFormatted
    },
    getTecnicosFormatted (tecnicos) {
      const tecnicosFormmatted = tecnicos ?  tecnicos.map((tec) => { // eslint-disable-line
        return {
          nome: tec?.pessoa?.pessoaFisica?.nome?.toUpperCase(),
          id: tec.id
        }
      }) : []

      const selectFormatted = _.orderBy(tecnicosFormmatted, ['nome'], ['asc'])
      return selectFormatted
    },
    getTipoFormatado (codigo) {
      return EnumFormatter.getTipoFormatado(codigo)
    },
    async consultar () {
      this.loadingTable = true
      this.filtroSearch.simplificado = false
      this.filtroSearch.pagina = 0
      this.page = 1

      if (this.dataCadastro && this.dataCadastro.length > 1) {
        this.filtroSearch.dataInicio = this.dataCadastro[0]
        this.filtroSearch.dataFim = this.dataCadastro[1]
      } else {
        this.filtroSearch.dataInicio = null
        this.filtroSearch.dataFim = null
      }

      this.processos = await this.findProcessosByFilter(this.filtroSearch)
      this.loadingTable = false
    },

    exibirBuscaPorLote () {
      this.showPesquisaLote = !this.showPesquisaLote
    },

    async changePage (newPage) {
      this.page = newPage
      this.filtroSearch.pagina = newPage - 1

      this.loadingTable = true
      this.processos = await this.findProcessosByFilter(this.filtroSearch)
      this.loadingTable = false
    },

    async limpar () {
      this.filtroSearch = {
        pagina: 0,
        nomeInteressado: null,
        cpfInteressado: null,
        dataInicio: [],
        dataFim: [],
        tiposProcesso: [],
        municipios: [],
        situacoesProcesso: [],
        setoresAtuais: [],
        setoresPassados: ['PREFEITURA'],
        responsaveisAtuais: [],
        responsaveisPassados: [],
        tipoPesquisa: 'SIMPLIFICADO',
        numeroProcesso: null,
        numeroComprovante: null,
        nomePlanilha: null
      }

      this.file = null

      this.page = 1
      this.dataCadastro = []
      this.loadingTable = true

      this.processos = await this.findProcessosByFilter(this.filtroSearch)
      this.loadingTable = false
    },
    async handleChangeSetorPassados () {
      this.filtroSearch.responsaveisPassados = null
      if (this.filtroSearch.setoresPassados && this.filtroSearch.setoresPassados.length > 0) {
        this.responsaveisPassados = await this.getTecnicosResponsaveis(this.filtroSearch.setoresPassados)
      }
    },
    async handleChangeSetorAtual () {
      this.filtroSearch.responsaveisAtuais = null
      if (this.filtroSearch.setoresAtuais && this.filtroSearch.setoresAtuais.length > 0) {
        this.responsaveisAtuais = await this.getTecnicosResponsaveis(this.filtroSearch.setoresAtuais)
      }
    },

    /*
     * Função que envia o processo, que veio do componente filho AppListagemProcessosRelatorios,
     * para a tela de relatorios, para ser exibido no modal
     */
    onClickedProcessoListagem (processo) {
      this.$emit('viewProcessosHasClicked', processo)
    },

    // Exporta csv com os dados buscado de acordo com o filtro escolhido
    getCsv () {
      this.confirmBox(
        'Ao confirmar será enviado para seu e-mail um arquivo CSV.',
        this.$messages.TITULO_WARNING, () => {
          this.getCsvDashboardRelatorios(this.filtroSearch)
          this.disableExportarCSV = true

          this.$alert(`O CSV está sendo gerado, e dentro de alguns minutos será enviado para seu e-mail
            uma mensagem com o anexo.`, 'Sucesso', {
            confirmButtonText: 'Ok',
            type: 'success'
          })

          this.disableExportarCSV = false
        },
        () => {}
      )
    },
    changeOrder (ordem) {
      this.changePage(1)

      if (ordem && ordem.column && ordem.prop) {
        if (ordem.prop === 'localizacoes') {
          this.filtroSearch.ordem = undefined
        } else if (ordem.prop === 'tipo.nome') {
          this.filtroSearch.ordem = 'tipo'
        } else {
          this.filtroSearch.ordem = ordem.prop
        }
        this.filtroSearch.ordemDirecao = ordem.order === 'ascending' ? 'ASC' : 'DESC'
      } else {
        this.filtroSearch.ordem = 'numeroProcesso'
        this.filtroSearch.ordemDirecao = 'DESC'
      }

      this.consultar()
    },
    formatLabelSetor (item) {
      if (process.env.ESTADO === 'ma') {
        return item.nome
      }

      if (item.codigo === 'TECNICO_DE_CAMPO') {
        return 'Técnico de campo'
      }

      if (item.setor === 'GP' && item.status.includes('ASSINATURA')) {
        return 'GP - Assinatura'
      }

      if (item.codigo.includes('ASSINATURA')) {
        return item.nome
      }

      return item.codigo
    },
    onSuccess (id, resumableFile, fileKey) {
      this.file = {
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size
      }
      this.filtroSearch.nomePlanilha = this.file.fileKey
    },

    removerDocumento () {
      this.file = null
    },

    baixarModelo () {
      this.getModeloRelatorio()
    }
  },

  watch: {
    countProcessos (value) {
      this.disableExportarCSV = !(value > 0)
    }
  }
}

</script>

<style scoped lang="scss">
@import '../../../../assets/styles/element-variables.scss';

.limpar {
  margin-right: 20px;
  color: $--color-primary;
  cursor: pointer;
  &:hover {
    font-weight: bold;
  }
}
.icon {
  margin-right: 7px;
}
.el-select {
  width: 100%;
}
.label {
  margin: 0;
  padding: 12px 0 8px 0px;
}
.button-row {
  margin-top: 10px;
  text-align: right;
}
.right {
  float: right;
  cursor: pointer;
  margin: 10px 0px;
}
.pagination {
    text-align: center;
}
.full-width {
    width: -webkit-fill-available;
}

/* Cards e gráficos */
.cardTotais:nth-child(-n + 2) {
  margin-bottom: 5%;
}

.cardTotais {
  width: 45%;
  margin-right: 20px;
}

.card-graficos {
  border: 2px solid #34495e;
  border-radius: 12px;
  padding: 5px;
  box-shadow: 0px 3px 6px #00000029;
  text-align: center;
}

.dashboard-info{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.dashboard-info-cards {
  width: 50%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 0 5% 0;
  justify-content: space-between;
}

.busca {
  padding: 12px 0 8px 0px;
  text-align: left;
  color: $--color-primary !important;
  cursor: pointer;
  &:hover {
    font-weight: bold;
  }
}

.dashboard-info-graficos {
  width: 50%;
  padding: 0 0 5% 0;
}

.el-radio-group /deep/ .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
  box-shadow: none;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

@media only screen and (max-width: 1256px) {
  .dashboard-info {
    flex-direction: column;
  }

  .dashboard-info-cards {
    width: auto;
    padding-right: 0;
  }

  .dashboard-info-graficos {
    width: auto;
  }

  .cardTotais {
    width: 45%;
  }

  .card-graficos {
    margin: 0;
  }

  .cardTotais:nth-child(2n) {
    margin-right: 0;
  }

}

.btn-download {
  text-decoration: underline;
  cursor: pointer;
  color: #f1f1f1;
}

.icon-info {
  font-size: 25;
  margin: 0 0 10px 5px;
}
</style>



// WEBPACK FOOTER //
// src/screens/relatorios/components/gerais/AppListagemProcessoAnalisados.vue